<template>
  <div class="right part" ref="positionRef">
    <div class="marvel-device iphone-x" ref="fixedIphone" :style="{
      left,
      top,
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }">
      <div class="notch">
        <div class="camera"></div>
        <div class="speaker"></div>
      </div>
      <div class="top-bar"></div>
      <div class="sleep"></div>
      <div class="bottom-bar"></div>
      <div class="volume"></div>
      <div class="overflow">
        <div class="shadow shadow--tr"></div>
        <div class="shadow shadow--tl"></div>
        <div class="shadow shadow--br"></div>
        <div class="shadow shadow--bl"></div>
      </div>
      <div class="inner-shadow"></div>
      <div class="screen">
        <div class="notch-pad">
          <p>{{domain}}</p>
        </div>
        <iframe :src="src" v-if="ready" @load="onReady" />
        <div class="loading-box" v-if="!iframeReady">
          <div class="loader">Loading...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash-es'

export default {
  props: {
    url: String,
    ready: Boolean
  },
  data () {
    return {
      top: null,
      left: null,
      scale: 1,
      loaded: false,
      iframeReady: false
    }
  },
  computed: {
    src () {
      const base = process.env.NODE_ENV === 'production' ? '/api' : 'https://preview-superchargify.herokuapp.com/api'
      return `${base}?url=${encodeURIComponent(this.url)}`
    },
    domain () {
      if (!this.ready) return ''

      const url = new URL(this.url)
      return url.host
    }
  },
  mounted () {
    window.addEventListener('resize', this.updatePosition, {
      capture: true,
      passive: true
    })

    this.$nextTick(this.updatePosition)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updatePosition)
  },
  methods: {
    onReady () {
      this.iframeReady = true
    },
    cacheSelectors () {
      if (this.iphone) return

      const elem = this.$refs.fixedIphone
      const iphone = elem.getBoundingClientRect()
      const height = elem.offsetHeight
      const width = elem.offsetWidth

      this.iphone = {
        height,
        width,
        y: iphone.y
      }
    },
    updatePosition: throttle(function () {
      this.cacheSelectors()

      const ref = this.$refs.positionRef
      if (!ref) return

      const refStyles = getComputedStyle(ref)

      if (!this.padding) {
        this.padding = parseInt(refStyles.getPropertyValue('padding-left')) * 2
      }

      const maxWidth = parseFloat(refStyles.getPropertyValue('width'))
      const maxHeight = window.innerHeight
      const previewHeight = this.iphone.height
      const previewWidth = this.iphone.width
      const scale = { height: 1, width: 1 }

      const widthDiff = previewWidth - maxWidth
      if (widthDiff > 0) {
        const newPreviewWidth = Math.floor(previewWidth - widthDiff)
        scale.width = newPreviewWidth / previewWidth
      }

      const heightDiff = previewHeight - maxHeight
      if (heightDiff > 0) {
        const newPreviewHeight = Math.floor(previewHeight - heightDiff)
        scale.height = newPreviewHeight / previewHeight
      }

      this.scale = Math.min(scale.width, scale.height, 1)

      const refRect = ref.getBoundingClientRect()
      const top = refRect.top + (refRect.height / 2) - (previewHeight / 2)
      const left = refRect.left + (refRect.width / 2) - (previewWidth / 2)

      this.top = `${Math.max(top, 0)}px`
      this.left = `${Math.max(left, 0)}px`
    }, 250)
  }
}
</script>

<style lang="scss">
.loading-box {
  height: calc(100% - 56px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #D9E2EC;

  position: absolute;
  top: 56px;
  left: 0;
  width: 100%;
  opacity: 0.9;
}

iframe {
  height: calc(100% - 56px);
  width: 100%;
  border: 0;
}

.notch-pad {
  height: 56px;
  background: #575757;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  p {
    margin: 0 0 4px 0;
    font-size: 12px;
    color: #fff;
    font-weight: normal;
    opacity: 0.95;
  }
}

.marvel-device {
  display: block;
  position: fixed;
  top: 15px;

  z-index: 1;
  will-change: transform;
  perspective: 1000;
}
</style>
